import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { UserInformationService } from 'src/app/services/TemplateServices/user-information.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './navbar.component.html',
  styleUrls: ["./navbar.component.scss"],
  selector: 'app-navbar',
})
export class NavbarComponent implements OnDestroy {

  // userChangesDetector: Se suscribre al servicio de usuarios para recibir cambios
  userChangesDetector: Subscription;

  // lvl: Nivel de dropdown
  lvl: number;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    public user: UserInformationService,
  ) {
    // ↓ Se suscribe al servicio de usuario
    this.userChangesDetector = this.user.emitter.subscribe((data: boolean) => {
      // ↓ Inicia las configuraciones de materializecss
      this.setMaterialize();
      // ↓ Actualiza la vista
      this.changeDetectorRef.markForCheck();
    });
  }

  // setMaterialize(): Método que inicia la configuración materializecss
  setMaterialize = () => {
    // ↓ Reinicia los niveles
    this.lvl = 0;
    // ↓ Verifca que se haya cargado el menú del usuario
    if (this.user.userMenu) {
      // ↓ Espera a que se haya formado el menú
      setTimeout(() => {
        const collapsible: NodeListOf<HTMLElement> = document.querySelectorAll('.collapsible');
        const dropdown: NodeListOf<HTMLElement> = document.querySelectorAll('.dropdown-nav');
        const sidenav: NodeListOf<HTMLElement> = document.querySelectorAll('.sidenav-nav');

        M.Dropdown.init(dropdown, { coverTrigger: false, constrainWidth: false });
        M.Collapsible.init(collapsible, { accordion: false });
        M.Sidenav.init(sidenav, {});
        document.querySelectorAll('.collapsible-header').forEach((elm: HTMLElement) => elm.tabIndex = -1);
        // last: si se establece entonces termina la inicialización del menú
        let last;
        // ↓ Itera mientras last no se establezca
        while (!last) {
          // ↓ Aumenta el nivel
          this.lvl++;
          // nextDropdown: guarda los menú del siguiente nivel
          const nextDropdown: NodeListOf<HTMLElement> = document.querySelectorAll(".dropdown-nav" + this.lvl);
          // ↓ Verifica si hay algún menú en el siguiente nivel y lo inicializa, de lo contrario establece last
          nextDropdown.length > 0 ? this.setDropdowns(nextDropdown, this.lvl - 1) : last = true;
        }
        // ↓ cambia el ícono de los submenú desplegables para saber si esta abierto o cerrado
        document.querySelectorAll(".change-icon").forEach((elm: HTMLElement) => {
          // ↓↓ Cambia la forma con el evento click
          elm.addEventListener("click", () => {
            elm.querySelector("i").innerHTML = elm.querySelector("i").innerHTML === "expand_more" ? "expand_less" : "expand_more";
          });
        });
        // ↓↓ Cierra todos los menús que estén abiertos
        document.querySelectorAll(".link-page").forEach((elm: HTMLElement) => {
          elm.addEventListener("click", () => { this.closeDropdowns(document.querySelectorAll("[menutype=active]")); });
        });
      }, 0);
    } else {
      // ↓ Si no ha cargado el menú, espera y reinicia el método
      setTimeout(() => { this.setMaterialize(); }, 100);
    }
  }

  /* Método que inicializa los menúes del nivel que recibe
    element: Listado de elementos
    lvl: Nivel del menú
  */
  setDropdowns(element: NodeListOf<HTMLElement>, lvl: number) {
    // ↓ Configuraciones materialize
    M.Dropdown.init(element, {
      // Establece coverTrigger si el nivel del menú es mayor a 0
      coverTrigger: lvl > 0 ? true : false,
      constrainWidth: false,
      closeOnClick: false,
      // onOpenStart(): Método que se ejecuta cuando se abre un menú
      onOpenStart: (el: Element) => {
        // ↓↓ Cierra los menús del mismo nivel que estén activos
        const elm: NodeListOf<HTMLElement> = document.querySelectorAll(`.${el.classList.value}[menuType=active]`);
        this.closeDropdowns(elm);
        // ↓ Marca el menú como activo
        el.setAttribute("menuType", "active");
      },
      // onCloseStart(): Método que se ejecuta cuando se cierra un menú
      onCloseStart: (el: Element) => {
        // ↓↓ Cierra los submenús asociados
        const elm: NodeListOf<HTMLElement> = document.querySelectorAll(`#${el.getAttribute("data-target")} a[menuType=active]`);
        this.closeDropdowns(elm);
      }
    });
  }

  /* closeDropdowns(): Método que cierra los menús recibido
    elm: Menús
  */
  closeDropdowns(elm: NodeListOf<HTMLElement>) {
    // ↓ Verifica que exita 1 o más menús
    if (elm.length > 0) {
      // ↓* Itera los menús y por c/u elimina la marca de activo y lo cierra
      elm.forEach((element: HTMLElement) => {
        element.removeAttribute("menuType");
        M.Dropdown.getInstance(element).close();
      });
    }
  }

  ngOnDestroy() {
    // ↓ Cancela la suscripción al servicio de usuarios
    this.userChangesDetector.unsubscribe();

    // ↓* Destruye las instancias de materializecss
    const collapsible: NodeListOf<HTMLElement> = document.querySelectorAll('.collapsible');
    const dropdown: NodeListOf<HTMLElement> = document.querySelectorAll('.dropdown-nav');
    const sidenav: NodeListOf<HTMLElement> = document.querySelectorAll('.sidenav-nav');

    collapsible.forEach((elm: HTMLElement) => M.Collapsible.getInstance(elm) ? M.Collapsible.getInstance(elm).destroy() : null);
    dropdown.forEach((elm: HTMLElement) => M.Dropdown.getInstance(elm) ? M.Dropdown.getInstance(elm).destroy() : null);
    sidenav.forEach((elm: HTMLElement) => M.Sidenav.getInstance(elm) ? M.Sidenav.getInstance(elm).destroy() : null);
    for (let i = 1; i <= this.lvl; i++) {
      document.querySelectorAll('.dropdown-nav' + i).forEach((elm: HTMLElement) => M.Dropdown.getInstance(elm) ? M.Dropdown.getInstance(elm).destroy() : null);
    }
  }

}
